import React, { useContext } from 'react';
import { useGlobalVariablesContext } from '../context/GlobalVariablesContext';
import { useTranslation } from 'react-i18next';
import MapContext from './Map/MapContext';
import { fromLonLat } from 'ol/proj';


const HomeButton = () => {
  const { config } = useGlobalVariablesContext();
  const { map } = useContext(MapContext);
  const { t } = useTranslation();

  if (!config) return; // Asegura que config esté cargado

  const center = config.center;
  const zoom = config.zoom;

  // Función para centrar la vista
  const handleButtonClick = () => {
    if (!map) return;

    const zoomActual = map.getView().getZoom();
    const centerActual = map.getView().getCenter();

    if (zoomActual !== zoom || centerActual !== center) {
      map.getView().setCenter(fromLonLat(center));
      map.getView().setZoom(zoom);
    }

  };

  return (
    <span
      className={`list-item`}
      onClick={handleButtonClick}
      style={{ cursor: 'pointer'}}
      title={t('Initial view')}

    >
        <i className={`bi bi-globe-americas`}></i>
    </span>
  );
};

export default HomeButton;
